import { DashboardTileType, IDashboardTileComponentProps } from "@components/dashboard";
import DashboardTileHeader from "@components/dashboard/DashboardTileHeader";
import { NoData } from "@components/table/NoData";
import InfoTile from "@components/tiles/infoTile";
import {
    GroupedInfoTileBackground,
    GroupedInfoTileContentWrapper,
    GroupInfoTileHeader
} from "@components/tiles/infoTile/InfoTile.styles";
import { getEmployeeLeaveBalance, ILeaveBalanceData } from "@pages/home/EmployeeTiles";
import { roundToDecimalPlaces } from "@utils/general";
import { logger } from "@utils/log";
import i18next from "i18next";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../contexts/appContext/AppContext.types";

interface IProps extends IDashboardTileComponentProps {
}

const EmployeeLeaveBalanceTile: React.FC<IProps> = ({ inEditMode }) => {
    const [leaveBalance, setLeaveBalance] = useState<ILeaveBalanceData[]>(null);
    const { t } = useTranslation("Home");
    const context = useContext(AppContext);

    useEffect(() => {
        const fetchLeaveBalance = async () => {
            try {
                const data = await getEmployeeLeaveBalance(context);
                if (data.length > 0) {
                    setLeaveBalance(data);
                }
            } catch (e) {
                logger.error(e);
            }
        };

        fetchLeaveBalance();
    }, [context]);

    return (<GroupedInfoTileBackground
        inEditMode={inEditMode}>
        <GroupInfoTileHeader>
            <DashboardTileHeader>{t("Home:EmployeeLeaveBalance.Heading")}</DashboardTileHeader>
        </GroupInfoTileHeader>

        {!leaveBalance?.length && <NoData isSimplified/>}
        <GroupedInfoTileContentWrapper cols={2} rows={2} $renderAsColumns>
            {leaveBalance?.map((item, i) => {
                const hasHours = !!item.VacationBalanceMinutes;
                const hours = roundToDecimalPlaces(1, item.VacationBalanceMinutes) / 60;
                const hoursLabel = hasHours ? i18next.t("Common:Time.Hours", { count: hours }) : null;
                return <InfoTile key={i} inEditMode={inEditMode} info={{
                    title: item.EmploymentName,
                    type: DashboardTileType.Info,
                    infoData: [{
                        value: item.VacationBalanceDays,
                        unit: i18next.t("Common:Time.Days", { count: item.VacationBalanceDays }).toString(),
                        label: hasHours ? `${hours} ${hoursLabel}` : null
                    }],
                    size: { w: 1, h: 1 }
                }} isGrouped/>;
            })}
        </GroupedInfoTileContentWrapper>
    </GroupedInfoTileBackground>);
};

export default EmployeeLeaveBalanceTile;